import { reactive } from "vue";

const state = reactive({
    count: 0,
});

const methods = {
    increase: function () {
        state.count++;
    },
    decrease: function () {
        state.count--;
    },
};


export default {
    state: state,
    methods: methods,
}
